import * as Sentry from '@sentry/browser';

export const handleChunkLoadError = (err) => {
  if (typeof window === 'undefined') {
    throw err;
  }

  if (!window.localStorage.getItem('reloaded')) {
    Sentry.captureMessage(err.message);
    window.alert('An unexpected error occurred, the page will be reloaded');
    window.localStorage.setItem('reloaded', true);
    window.location.reload();
    return new Promise(() => {});
  } else {
    window.localStorage.removeItem('reloaded');
  }
};
